import React, { useEffect } from "react";
import NavbarTop from "./../components/global/NavbarTop";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "./../redux/language/selector";
import UserGuideContent from "../components/UserGuide/UserGuideContent";

const UserGuidePage = () => {
  const { t } = useTranslation();
  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("guide-page.guide-page-title");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <>
      <NavbarTop />
      <UserGuideContent />
    </>
  );
};

export default UserGuidePage;
